import * as React from "react";
import './CustomCheckbox.css';
export default function CustomCheckBox({ value, setValue, text, colorCheckbox }) {
  const handleCheckboxChange = () => {
    setValue(!value);
  };
  return (
      <label className="custom-checkbox-container" >
        <input type="checkbox" checked={value} onChange={handleCheckboxChange} className="hidden-checkbox"/>
        <span style={colorCheckbox !== null ? {color: colorCheckbox} : {}} className={`custom-checkbox ${value ? 'checked' : ''}`} />
        <label onClick={handleCheckboxChange}  className="checkbox-label">{text}</label>
    </label>
  );
}
